import React, { useEffect, useState } from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import { Button, Row, Col, Card } from 'react-bootstrap';
import axios from 'axios';
import swal from 'sweetalert';
import { Icon } from '@iconify/react';
import { API_URL, formatDateAccordingTo } from '..';
import { useParams, useNavigate } from 'react-router-dom';

const ViewTruckExpensePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [expense, setExpense] = useState(null);
  const [currentUser, setCurrentUser] = useState(JSON.parse(localStorage.getItem('user') || '{}'));

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('user'));
    if (!storedUser) {
      window.location.href = '/sign-in';
    } else {
      setCurrentUser(storedUser);
      fetchExpense();
    }
  }, []);

  const fetchExpense = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/truck/single-expense/${id}`, {
        headers: {
          'Content-Type': 'application/json',
          Accept: '*/*',
        },
      });
      if (response.status === 200) {
        setExpense(response.data.truckExpenses);
      } else {
        swal('Error', response.data.message || 'Failed to fetch expense', 'error');
      }
    } catch (error) {
      swal('Error', 'Failed to fetch expense: ' + error.message, 'error');
    }
  };

  const handlePrint = () => {
    window.print();
  };

  const formatDate = (date) => {
    if (!date) return '-';
    const d = new Date(date);
    const day = d.getDate();
    const month = d.toLocaleString('default', { month: 'short' });
    const year = d.getFullYear();
    return `${day} ${month} ${year}`;
  };
  return (
    <MasterLayout>
     
      <div className="container py-5 expense-content">
        <Row>
          <Col md={12} className="text-end">
            <div className="d-flex justify-content-end mb-3 no-print">
              <Button
                variant="primary"
                className="me-2"
                // onClick={() => navigate(`/expense/edit/${id}`)}
              >
                <Icon icon="bi:pencil" className="me-2" />
                Edit
              </Button>
              <Button variant="success" onClick={handlePrint}>
                <Icon icon="bi:printer" className="me-2" />
                Print
              </Button>
            </div>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col lg={8}>
            {/* Header */}
            <Card className="shadow-sm border-0 mb-0" style={{ borderRadius: 0 }}>
              <Card.Body className="p-4">
                <div className="d-flex align-items-center justify-content-between flex-wrap">
                  <div>
                    <img
                      src={API_URL + currentUser?.business_logo}
                      alt={currentUser?.business_name || 'Logo'}
                      className="logo-img"
                    />
                  </div>
                  <div className="text-end">
                    <h5 className="mb-1">{currentUser?.business_name || '-'}</h5>
                    <p className="mb-0 text-muted">{currentUser?.email || '-'}</p>
                    <p className="mb-0 text-muted">{currentUser?.phone || '-'}</p>
                  </div>
                </div>
              </Card.Body>
            </Card>

            {/* Expense Information */}
            {expense ? (
              <Card className="shadow-sm border-0" style={{ borderRadius: 0 }}>
                <Card.Header className="bg-white border-bottom">
                  <h6 className="h6 mb-0">Expense Information</h6>
                </Card.Header>
                <Card.Body className="p-3">
                  <Row>
                    <Col md={12} className="mb-3">
                      <strong>Title:</strong> {expense.expense_title || '-'}
                    </Col>
                 
                    <Col md={12} className="mb-3">
                      <strong>Truck:</strong>{' '}
                      <span>{expense?.truck?.name}</span>
                    </Col>
                    <Col md={12} className="mb-3">
                      <strong>Amount:</strong> ${parseFloat(expense.amount || 0).toFixed(2)}
                    </Col>
                    <Col md={12} className="mb-3">
                      <strong>Date:</strong> {formatDate(expense.date)}
                    </Col>
                    <Col md={12} className="mb-3">
                      <strong>Payment Method:</strong>{' '}
                      {expense.payment_method
                        ? expense.payment_method.charAt(0).toUpperCase() +
                          expense.payment_method.slice(1)
                        : '-'}
                    </Col>
                    <Col md={12} className="mb-3">
                      <strong>Description:</strong> {expense.expense_details || '-'}
                    </Col>
                    <Col md={12} className="mb-3">
                      <strong>Created At:</strong> {formatDate(expense.date)}
                    </Col>
                    {expense.attachment_file && (
                      <Col md={12} className="mb-3">
                        <strong>Attachment:</strong>{' '}
                        <a
                          href={expense.attachment_file}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-primary no-print"
                        >
                          <Icon icon="bi:eye" className="me-1" />
                          View Attachment
                        </a>
                      </Col>
                    )}
                  </Row>
                </Card.Body>
              </Card>
            ) : (
              <p>Loading...</p>
            )}

            {/* Print Footer */}
            <div className="print-footer">
              This expense is system-generated; no signature is required.
            </div>
          </Col>
        </Row>
      </div>
    </MasterLayout>
  );
};

export default ViewTruckExpensePage;